import React, { useEffect, useState } from 'react';
import managecookies from "../services/managecookies";
import Loading from './Loading';
import utils from "../services/utils";
import managedata from "../services/managedata";
import GeneralProfile from "./profilepages/GeneralProfile";
import RequestsNBues from "./profilepages/RequestsNBues"; // assuming you have this component

const ProfileArea = () => {
    const [userData, setUserData] = useState(null);
    const [sectionView, setSectionView] = useState('general')

    const handleLogOut= () =>{
        let data = {
            'data': {
            },
            'type': {'act': 'logout'}
        }
        managedata.sendData(data)
        managecookies.removeAllCookies()
        localStorage.removeItem('area-list');
        window.location.reload();
    }


    const renderUserInfo = () => {
        return <span>{userData.privateName} {userData.lastName}</span>;
    };

    useEffect(() => {
        const data = JSON.parse(managecookies.getCookieVal('userData'));
        setUserData(data);
    }, []);

    // Show loading state while data is not yet loaded or business array is missing
    if (!userData || !userData.business) {
        return <Loading />;
    }
    const renderSettingView = () => {
        switch (sectionView) {
            case 'general':
                return <GeneralProfile userData={userData}/>
            case 'buies':
                return <RequestsNBues/>
        }
    }

    return (
        <div>
            <div className="user-info">
                <span>{renderUserInfo()} </span>
            </div>
            <div className={'setttings-container-modal'}>
                <section className="side-menu">
                    <ul className="menu-list">
                        <li onClick={() => setSectionView('general')}>{utils.useLang('GENERAL')}</li>
                        <li onClick={() => setSectionView('buies')}>{utils.useLang('MY_BUES')}</li>
                        <li><button onClick={handleLogOut}>{utils.useLang('LOG_OUT')}</button></li>
                    </ul>
                </section>
                <div className={'area-full-container'}>
                    {renderSettingView()}
                </div>
            </div>
        </div>
    );
};

export default ProfileArea;
